/*
 * Clyro Native Cart Drawer
 * Lightweight Shopify AJAX cart UI. No framework, no page-load Cart API call.
 */
(function () {
  'use strict';

  // Theme editor can evaluate the same asset again after a section redraw.
  if (window.clyroNativeCartBoot) { window.clyroNativeCartBoot(document); return; }
  window.clyroNativeCartVersion = 'drawer-only-ready-4';
  var initialized = new WeakSet();
  var instances = new WeakMap();
  var activeSections = new Map();
  var handledAdds = new Set();

  function parseJSON(node, fallback) {
    try { return JSON.parse(node.textContent || ''); } catch (_) { return fallback; }
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeImage(url, width) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(width || 180));
      return parsed.toString();
    } catch (_) { return String(url); }
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function ensureMilestoneStyles(doc) {
    if (!doc || !doc.head || !doc.createElement || !doc.getElementById || doc.getElementById('clyro-cd-milestone-layout')) return;
    var style = doc.createElement('style');
    style.id = 'clyro-cd-milestone-layout';
    style.textContent =
      '.clyro-cd-rewards[data-staggered-milestones="true"] .clyro-cd-progress{margin-bottom:68px!important}' +
      '.clyro-cd-rewards[data-staggered-milestones="true"] .clyro-cd-progress__label{width:max-content!important;max-width:none!important;white-space:nowrap!important;overflow-wrap:normal!important;z-index:2}' +
      '.clyro-cd-rewards[data-staggered-milestones="true"] .clyro-cd-progress__label[data-cd-milestone-label-row="0"]{top:calc(50% + var(--cd-marker-size,28px)/2 + 5px)!important}' +
      '.clyro-cd-rewards[data-staggered-milestones="true"] .clyro-cd-progress__label[data-cd-milestone-label-row="1"]{top:calc(50% + var(--cd-marker-size,28px)/2 + 29px)!important}' +
      '.clyro-cd-progress__label[data-cd-milestone-edge="end"]{left:100%!important;right:auto!important;transform:translateX(-100%)!important;text-align:right!important}' +
      '.clyro-cd-progress__label[data-cd-milestone-edge="start"]{left:0!important;right:auto!important;transform:none!important;text-align:left!important}';
    doc.head.appendChild(style);
  }

  function init(root) {
    if (!root || initialized.has(root)) return;
    ensureMilestoneStyles(document);
    var configNode = root.querySelector('[data-cd-config]');
    var config = parseJSON(configNode, {});
    var experiment = null;
    var shipping = null;
    var shippingMutationBusy = false;
    function onShippingMutation(event) {
      shippingMutationBusy = !!(event.detail && event.detail.busy);
      updateShipping();
    }
    function updateShipping() {
      if (destroyed || !cart) return;
      try {
        if (!shipping && window.clyroCartShipping) shipping = window.clyroCartShipping(root);
        if (shipping) shipping.update(cart, isOpen, busy || shippingMutationBusy);
      } catch (_) { /* A rate-display failure must never block the cart or checkout. */ }
    }
    var sectionKey = String(config.sectionId || 'default');
    var priorInstance = activeSections.get(sectionKey);
    var inThemeEditor = !!(window.Shopify && window.Shopify.designMode);
    if (priorInstance && priorInstance.root !== root) priorInstance.destroy();
    initialized.add(root);
    var configText = configNode ? configNode.textContent : '';
    var panel = root.querySelector('[data-cd-panel]');
    var body = root.querySelector('[data-cd-body]');
    var itemsHost = root.querySelector('[data-cd-items]');
    var emptyHost = root.querySelector('[data-cd-empty]');
    var countNodes = root.querySelectorAll('[data-cd-count]');
    var rewardHost = root.querySelector('[data-cd-rewards]');
    var rewardCopy = root.querySelector('[data-cd-reward-copy]');
    var rewardFill = root.querySelector('[data-cd-progress-fill]');
    var rewardMarkers = root.querySelector('[data-cd-progress-markers]');
    var rewardLegend = root.querySelector('[data-cd-progress-legend]');
    var giftHost = root.querySelector('[data-cd-gift-host]');
    var upsellHost = root.querySelector('[data-cd-upsells]');
    var upsellLoading = root.querySelector('[data-cd-upsells-loading]');
    var upsellControls = root.querySelector('[data-cd-upsell-controls]');
    var upsellAutoplayTimer = 0;
    var upsellScrollTimer = 0;
    var upsellScrollHandler = null;
    var upsellNavigationBusy = false;
    var upsellWrapTarget = null;
    var upsellWrapClone = null;
    var subtotalNode = root.querySelector('[data-cd-subtotal]');
    var savingsNode = root.querySelector('[data-cd-savings]');
    var inlineSavingsNode = root.querySelector('[data-cd-inline-savings]');
    var originalSubtotalNode = root.querySelector('[data-cd-original-subtotal]');
    var errorNode = root.querySelector('[data-cd-error]');
    var checkoutButton = root.querySelector('[data-cd-checkout]');
    var noteInput = root.querySelector('[data-cd-note]');
    var discountInput = root.querySelector('[data-cd-discount-input]');
    var discountStatus = root.querySelector('[data-cd-discount-status]');
    var timerNode = root.querySelector('[data-cd-timer-value]');
    var timerBar = root.querySelector('[data-cd-timer]');
    var expiryModal = root.querySelector('[data-cd-expiry-modal]');
    var expiryCountdown = root.querySelector('[data-cd-expiry-countdown]');
    var termsInput = root.querySelector('[data-cd-terms]');
    var floatingCount = document.querySelectorAll('[data-cd-floating-count]');
    var cart = null;
    var isOpen = false;
    var destroyed = false;
    var busy = false;
    var busyCount = 0;
    var idleWaiters = [];
    var checkoutPending = false;
    var renderedRevision = 0;
    var checkoutAttempt = 0;
    var cartFailure = 0;
    var giftAttemptSignature = '';
    var noteRequest = Promise.resolve();
    function localIdle() {
      return busy ? new Promise(function (resolve) { idleWaiters.push(resolve); }) : Promise.resolve();
    }
    function cancelCheckout() {
      if (window.clyroShop && window.clyroShop.lockCheckout) window.clyroShop.lockCheckout(false);
      checkoutAttempt += 1;
      checkoutPending = false;
      if (checkoutButton && !checkoutStarted) {
        checkoutButton.classList.remove('is-loading');
        checkoutButton.disabled = !cart || !cart.item_count;
      }
      syncBusyControls();
    }
    var lastFocus = null;
    var lockedScrollY = 0;
    var lockedBodyStyles = null;
    var lockedHtmlStyles = null;
    var fetchToken = 0;
    var lineFeedback = Object.create(null);
    var giftSyncing = false;
    var pendingDiscount = '';
    var pendingDiscountAt = 0;
    var eligibleRewardCode = '';
    var recommendationsFor = '';
    var timerHandle = null;
    var timerEnd = 0;
    var timerLines = '';
    var timerDuration = '';
    var graceEnd = 0;
    var checkoutStarted = false;
    var expiryClearing = false;
    var timerKey = 'clyro:cart-timer:' + (config.sectionId || 'default');
    var timerCartKey = timerKey + ':lines';
    var timerDurationKey = timerKey + ':duration';
    var noteHandle = null;

    function refreshConfig() {
      var nextNode = root.querySelector('[data-cd-config]');
      if (!nextNode) return;
      var nextText = nextNode.textContent || '';
      if (nextNode === configNode && nextText === configText) return;
      var nextConfig = parseJSON(nextNode, null);
      if (!nextConfig) return;
      var previousMinutes = Number(config.timerMinutes) || 0;
      config = nextConfig;
      if (experiment) config = experiment.apply(config);
      configNode = nextNode;
      configText = nextText;
      var nextMinutes = Number(config.timerMinutes) || 0;
      if (previousMinutes !== nextMinutes) {
        stopTimer(true);
        if (nextMinutes && isOpen && cart && cart.item_count > 0) resetTimer();
      }
    }

    var rewards = Array.prototype.map.call(
      root.querySelectorAll('[data-cd-reward-goal]'),
      function (node) {
        return {
          threshold: Number(node.getAttribute('data-threshold')) || 0,
          before: node.getAttribute('data-before') || '',
          reached: node.getAttribute('data-reached') || '',
          code: node.getAttribute('data-code') || '',
          kind: node.getAttribute('data-kind') || 'reward',
          label: node.getAttribute('data-label') || '',
          icon: node.getAttribute('data-icon') || 'auto',
          iconUrl: node.getAttribute('data-icon-url') || '',
          priority: Number(node.getAttribute('data-priority')) || 0
        };
      }
    ).filter(function (goal) { return goal.threshold > 0; })
      .sort(function (a, b) { return a.threshold - b.threshold || a.priority - b.priority; })
      .filter(function (goal, index, all) {
        return index === all.length - 1 || goal.threshold !== all[index + 1].threshold;
      });

    var gifts = Array.prototype.map.call(
      root.querySelectorAll('[data-cd-gift-goal]'),
      function (node) {
        return {
          blockId: node.getAttribute('data-block-id') || '',
          threshold: Number(node.getAttribute('data-threshold')) || 0,
          variantId: Number(node.getAttribute('data-variant-id')) || 0,
          productId: Number(node.getAttribute('data-product-id')) || 0,
          title: node.getAttribute('data-title') || '',
          image: node.getAttribute('data-image') || '',
          message: node.getAttribute('data-message') || '',
          mode: node.getAttribute('data-mode') || 'claim',
          removeBelow: node.getAttribute('data-remove-below') === 'true'
        };
      }
    ).filter(function (gift) { return gift.threshold > 0 && gift.variantId; })
      .sort(function (a, b) { return a.threshold - b.threshold; });

    function money(cents, display, decimalStyle) {
      var value = (Number(cents) || 0) / 100;
      var wholeAmount = Math.round(Number(cents) || 0) % 100 === 0;
      var digits = config.currency === 'JPY' ? 0 : 2;
      try {
        var format = {
          style: 'currency',
          currency: config.currency || 'USD',
          minimumFractionDigits: decimalStyle === 'hide_zero' && wholeAmount ? 0 : digits,
          maximumFractionDigits: decimalStyle === 'hide_zero' && wholeAmount ? 0 : digits
        };
        if (display) format.currencyDisplay = display;
        return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', format).format(value);
      } catch (_) {
        var number = value.toFixed(decimalStyle === 'hide_zero' && wholeAmount ? 0 : digits);
        if (display === 'code') return (config.currency || 'USD') + ' ' + number;
        return (window.clyroShop && window.clyroShop.money && decimalStyle !== 'hide_zero') ? window.clyroShop.money(cents) : '$' + number;
      }
    }

    function summaryMoney(cents) {
      return formattedSummaryMoney(cents, config.subtotalCurrencyStyle, config.subtotalDecimalStyle);
    }

    function formattedSummaryMoney(cents, style, decimalStyle) {
      var currencyFormat = style === 'match' || !style ? config.subtotalCurrencyStyle : style;
      var decimals = decimalStyle === 'match' || !decimalStyle ? config.subtotalDecimalStyle : decimalStyle;
      return money(cents, currencyFormat === 'code' ? 'code' : 'narrowSymbol', decimals);
    }

    function savingsMoney(cents) {
      return formattedSummaryMoney(cents, config.savingsCurrencyStyle, config.savingsDecimalStyle);
    }

    function originalMoney(cents) {
      return formattedSummaryMoney(cents, config.originalCurrencyStyle, config.originalDecimalStyle);
    }

    function cartDiscount(data) {
      if (!data) return 0;
      var original = Number(data.original_total_price);
      var total = Number(data.total_price);
      if (data.original_total_price != null && data.total_price != null && Number.isFinite(original) && Number.isFinite(total)) {
        return Math.max(0, original - total);
      }
      return Math.max(0, Number(data.total_discount) || 0);
    }

    function savingsText(template, amount) {
      template = String(template || 'You save [amount]');
      if (template.indexOf('[amount]') !== -1) return template.replace(/\[amount\]/g, amount);
      // Repair legacy labels such as "You save $22.00". The amount is always
      // generated from this cart, even if the editable label lacks a placeholder.
      template = template.replace(/(?:[A-Z]{3}\s*|[$€£¥]\s*)\d[\d.,]*(?:\s*[A-Z]{3})?/g, '')
        .replace(/\d[\d.,]*\s*(?:[A-Z]{3}|[$€£¥])/g, '').trim();
      return (template || 'You save') + ' ' + amount;
    }

    function cartSubtotal(data) {
      if (!data) return 0;
      if (typeof data.items_subtotal_price === 'number') return data.items_subtotal_price;
      return Number(data.total_price) || 0;
    }

    function qualifyingSubtotal(data) {
      if (!data || !Array.isArray(data.items)) return 0;
      return data.items.reduce(function (sum, item) {
        var properties = item.properties || {};
        if (properties._clyro_gift) return sum;
        return sum + (Number(item.final_line_price) || 0);
      }, 0);
    }

    function setBusy(on) {
      busyCount = Math.max(0, busyCount + (on ? 1 : -1));
      busy = busyCount > 0;
      if (!busy) { var waiting = idleWaiters.splice(0); waiting.forEach(function (done) { done(); }); }
      root.classList.toggle('is-busy', busy);
      syncBusyControls();
      updateShipping();
    }

    function syncBusyControls() {
      if (checkoutButton) checkoutButton.setAttribute('aria-disabled', String(!cart || !cart.item_count || checkoutPending || checkoutStarted));
      root.querySelectorAll('[data-cd-quantity],[data-cd-remove],[data-cd-addon-toggle],[data-cd-claim-gift]').forEach(function (control) {
        control.disabled = busy || checkoutPending || checkoutStarted || control.hasAttribute('data-cd-stock-disabled');
      });
    }

    function showError(message) {
      if (message && experiment) experiment.track('cart_error', {currency:config.currency});
      if (!errorNode) return;
      errorNode.textContent = message || '';
      errorNode.classList.toggle('is-visible', !!message);
      if (message) errorNode.setAttribute('role', 'alert');
      else errorNode.removeAttribute('role');
    }

    function syncGlobalCount(count) {
      var next = Math.max(0, Number(count) || 0);
      var all = document.querySelectorAll('[data-clyro-cart-count], [data-cd-floating-count]');
      for (var i = 0; i < all.length; i += 1) all[i].textContent = String(next);
      try {
        if (window.Alpine && window.Alpine.store && window.Alpine.store('cart')) {
          window.Alpine.store('cart').item_count = next;
        }
      } catch (_) {}
    }

    function announce(message) {
      var live = root.querySelector('[data-cd-live]');
      if (!live) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = message || ''; }, 20);
    }

    function lockPage() {
      // Shopify scrolls the preview when sections/blocks are selected. Locking
      // its body would strand merchants at the bottom of the page.
      if (inThemeEditor) return;
      var bodyEl = document.body;
      if (!bodyEl || bodyEl.hasAttribute('data-clyro-cart-locked')) return;
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      function captureStyles(element, properties) {
        var result = {};
        properties.forEach(function (property) {
          result[property] = {
            value: element.style.getPropertyValue(property),
            priority: element.style.getPropertyPriority(property)
          };
        });
        return result;
      }
      lockedBodyStyles = captureStyles(bodyEl, ['position', 'top', 'left', 'right', 'width', 'overflow', 'padding-right']);
      lockedHtmlStyles = captureStyles(document.documentElement, ['overflow']);
      bodyEl.setAttribute('data-clyro-cart-locked', 'true');
      bodyEl.style.position = 'fixed';
      bodyEl.style.top = '-' + lockedScrollY + 'px';
      bodyEl.style.left = '0';
      bodyEl.style.right = '0';
      // Let fixed positioning resolve width from left + right. Setting width:100%
      // as well can make the page wider than the viewport on mobile browsers.
      bodyEl.style.width = 'auto';
      bodyEl.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    function unlockPage() {
      var bodyEl = document.body;
      if (!bodyEl || !lockedBodyStyles || !bodyEl.hasAttribute('data-clyro-cart-locked')) return;
      bodyEl.removeAttribute('data-clyro-cart-locked');
      function restoreStyles(element, snapshot) {
        if (!snapshot) return;
        Object.keys(snapshot).forEach(function (property) {
          var prior = snapshot[property];
          if (prior.value) element.style.setProperty(property, prior.value, prior.priority);
          else element.style.removeProperty(property);
        });
      }
      restoreStyles(bodyEl, lockedBodyStyles);
      restoreStyles(document.documentElement, lockedHtmlStyles);
      lockedBodyStyles = null;
      lockedHtmlStyles = null;
      window.scrollTo(0, lockedScrollY);
    }

    function timeLabel(seconds) {
      var minutes = Math.floor(Math.max(0, seconds) / 60);
      return minutes + ':' + String(Math.max(0, seconds) % 60).padStart(2, '0');
    }

    function stopTimer(clearStored) {
      if (timerHandle) window.clearInterval(timerHandle);
      timerHandle = null;
      graceEnd = 0;
      if (expiryModal) expiryModal.hidden = true;
      if (timerBar) timerBar.hidden = true;
      if (clearStored) {
        timerEnd = 0;
        timerLines = '';
        timerDuration = '';
        try {
          window.sessionStorage.removeItem(timerKey);
          window.sessionStorage.removeItem(timerCartKey);
          window.sessionStorage.removeItem(timerDurationKey);
        } catch (_) {}
      }
    }

    function resetTimer() {
      if (!config.timerMinutes || !cart || cart.item_count < 1 || checkoutStarted) return;
      timerEnd = Date.now() + Number(config.timerMinutes) * 60000;
      timerLines = cartLineSignature(cart);
      timerDuration = String(Number(config.timerMinutes));
      graceEnd = 0;
      if (expiryModal) expiryModal.hidden = true;
      try {
        window.sessionStorage.setItem(timerKey, String(timerEnd));
        window.sessionStorage.setItem(timerCartKey, timerLines);
        window.sessionStorage.setItem(timerDurationKey, timerDuration);
      } catch (_) {}
      if (isOpen) startTimer();
    }

    function cartLineSignature(data) {
      if (!data || !Array.isArray(data.items)) return '';
      return data.items.map(function (item) { return String(item.key) + ':' + item.quantity; }).sort().join('|');
    }

    function cartLinesMatch(first, second) {
      if (!first || !second || !Array.isArray(first.items) || !Array.isArray(second.items)) return false;
      if (first.item_count !== second.item_count || first.items.length !== second.items.length) return false;
      return cartLineSignature(first) === cartLineSignature(second);
    }

    function clearExpiredCart() {
      if (expiryClearing || busy || checkoutStarted || !isOpen || document.hidden || !cart || !cart.item_count) return;
      expiryClearing = true;
      var expiredAt = timerEnd;
      setBusy(true);
      if (window.clyroShop && window.clyroShop.clearIfUnchanged) {
        var expected = cart;
        window.clyroShop.clearIfUnchanged(expected, function () {
          return !checkoutPending && !checkoutStarted && isOpen && !document.hidden && timerEnd === expiredAt;
        }).then(function (fresh) {
          render(fresh);
          if (fresh.item_count) resetTimer();
        }).catch(function (error) { showError(error.message); resetTimer(); })
          .finally(function () { expiryClearing = false; setBusy(false); });
        return;
      }
      fetch(config.cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error(config.errorMessage || 'The cart could not be loaded.');
          return response.json();
        }).then(function (fresh) {
          if (checkoutStarted || !isOpen || document.hidden || timerEnd !== expiredAt) return null;
          if (fresh.item_count < 1) return fresh;
          // Another tab or cart action can replace items without changing the item count.
          // In that case, leave the customer's new cart intact and start a fresh timer.
          if (!cartLinesMatch(cart, fresh)) {
            cart = fresh;
            resetTimer();
            return fresh;
          }
          return fetch(config.clearUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          }).then(function (response) {
            if (!response.ok) throw new Error(config.errorMessage || 'The cart could not be updated.');
            return response.json();
          });
        }).then(function (updated) {
          if (updated && Array.isArray(updated.items)) render(updated);
        }).catch(function (error) {
          showError(error.message || config.errorMessage);
          resetTimer();
        }).finally(function () {
          expiryClearing = false;
          setBusy(false);
        });
    }

    function showExpiryWarning() {
      if (!expiryModal || expiryClearing || !isOpen || document.hidden || checkoutStarted) return;
      if (expiryModal.hidden) {
        expiryModal.hidden = false;
        graceEnd = Date.now() + Math.max(1, Number(config.timerGraceMinutes) || 5) * 60000;
        var firstButton = expiryModal.querySelector('[data-cd-expiry-checkout]');
        if (firstButton) firstButton.focus({ preventScroll: true });
      }
      var seconds = Math.max(0, Math.ceil((graceEnd - Date.now()) / 1000));
      if (expiryCountdown) expiryCountdown.textContent = timeLabel(seconds);
      if (seconds === 0) clearExpiredCart();
    }

    function tickTimer() {
      refreshConfig();
      if (!timerNode || !timerEnd || !isOpen || !cart || cart.item_count < 1 || checkoutStarted) return;
      if (document.hidden) {
        // Offer the full grace period while the drawer is visible, never in a background tab.
        if (expiryModal && !expiryModal.hidden) { expiryModal.hidden = true; graceEnd = 0; }
        return;
      }
      var seconds = Math.max(0, Math.ceil((timerEnd - Date.now()) / 1000));
      timerNode.textContent = timeLabel(seconds);
      if (seconds > 0) return;
      if (config.timerExpiryAction === 'empty') clearExpiredCart();
      else if (config.timerExpiryAction === 'warning') showExpiryWarning();
      else resetTimer();
    }

    function startTimer() {
      if (!timerNode || !config.timerMinutes || !isOpen || !cart || cart.item_count < 1 || checkoutStarted) return;
      if (timerBar) timerBar.hidden = false;
      // A changed section setting must replace the old session deadline.
      // Older theme versions have no duration key, so start a fresh timer once.
      var storedDuration = timerDuration;
      if (!storedDuration) try { storedDuration = window.sessionStorage.getItem(timerDurationKey); } catch (_) {}
      if (storedDuration !== String(Number(config.timerMinutes))) {
        resetTimer();
        return;
      }
      timerDuration = storedDuration;
      var storedLines = timerLines;
      if (!storedLines) try { storedLines = window.sessionStorage.getItem(timerCartKey) || ''; } catch (_) {}
      if (storedLines !== cartLineSignature(cart)) {
        resetTimer();
        return;
      }
      timerLines = storedLines;
      if (!timerEnd) {
        try { timerEnd = Number(window.sessionStorage.getItem(timerKey)) || 0; } catch (_) {}
        if (!timerEnd) resetTimer();
      }
      tickTimer();
      if (!timerHandle) timerHandle = window.setInterval(tickTimer, 1000);
    }

    function openDrawer(options) {
      options = options || {};
      if (options.source !== 'header-cart' && options.source !== 'floating-cart' && options.source !== 'add-to-cart' && options.source !== 'checkout-return') return;
      refreshConfig();
      if (isOpen || destroyed || config.enabled === false || root.isConnected === false) return;
      if (!experiment && window.clyroCartExperiment) experiment = window.clyroCartExperiment(root);
      if (experiment) config = experiment.apply(config);
      isOpen = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      lockPage();
      window.requestAnimationFrame(function () {
        if (!isOpen || destroyed || root.isConnected === false) return;
        root.classList.add('is-open');
        if (panel) panel.focus({ preventScroll: true });
      });
      if (!cart || options.refresh === true) fetchCart();
      else render(cart);
      track('cart_drawer_open', { source: options.source || 'unknown' });
    }

    function closeDrawer(reason) {
      cancelCheckout();
      if (reason === 'user') clearCheckoutReturn();
      if (reason === 'user' && isOpen) document.dispatchEvent(new CustomEvent('clyro:drawer-closed'));
      if (!isOpen) return;
      isOpen = false;
      clearUpsellAutoplay();
      updateShipping();
      stopTimer(false);
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      unlockPage();
      window.setTimeout(function () {
        if (!isOpen) root.hidden = true;
      }, 270);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      track('cart_drawer_close', {});
    }

    function track(eventName, detail) {
      try {
        if (experiment) experiment.track(eventName, Object.assign({currency:config.currency},detail||{}));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
      } catch (_) {}
    }

    function fetchCart() {
      var token = ++fetchToken;
      setBusy(true);
      var read = window.clyroShop && window.clyroShop.refresh
        ? window.clyroShop.refresh({ throwOnError: true })
        : fetch(config.cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
          .then(function (response) { if (!response.ok) throw new Error(config.errorMessage); return response.json(); });
      return read.then(function (data) {
        if (token !== fetchToken || destroyed) return data;
        render(data);
        return data;
      }).catch(function (error) {
        showError(error.message || config.errorMessage);
        return null;
      }).finally(function () { setBusy(false); });
    }

    function itemProperties(item) {
      var properties = item.properties || {};
      var keys = Object.keys(properties).filter(function (key) {
        return key.charAt(0) !== '_' && properties[key] != null && properties[key] !== '';
      });
      if (!keys.length) return '';
      return '<ul class="clyro-cd-item__properties">' + keys.map(function (key) {
        return '<li>' + escapeHTML(key) + ': ' + escapeHTML(properties[key]) + '</li>';
      }).join('') + '</ul>';
    }

    function itemDiscounts(item) {
      var discounts = item.line_level_discount_allocations || [];
      if (!discounts.length) return '';
      return '<div class="clyro-cd-item__discounts">' + discounts.map(function (allocation) {
        var title = allocation.discount_application && allocation.discount_application.title;
        return title ? escapeHTML(title) + ' −' + money(allocation.amount) : '−' + money(allocation.amount);
      }).join('<br>') + '</div>';
    }

    // Identity survives discount-driven line-key changes without confusing
    // different variants, selling plans, or personalized lines.
    function lineIdentity(item) {
      var properties = item.properties || {};
      var plan = item.selling_plan_allocation;
      return JSON.stringify([item.variant_id || item.id,
        Object.keys(properties).sort().map(function (key) { return [key, properties[key]]; }),
        plan && plan.selling_plan && plan.selling_plan.id || null]);
    }

    // Shopify can split one customer-visible product into separate paid/free
    // lines when an automatic Buy X Get Y discount is applied. Keep the raw
    // lines for mutations and checkout, but present one coherent drawer row.
    function cartRows(data) {
      if (!data || !Array.isArray(data.items)) return [];
      var groups = [];
      var byIdentity = Object.create(null);
      data.items.forEach(function (item) {
        var identity = lineIdentity(item);
        var group = byIdentity[identity];
        if (!group) {
          group = Object.assign({}, item, {
            _clyroLines: [],
            quantity: 0,
            final_line_price: 0,
            original_line_price: 0,
            line_price: 0,
            total_discount: 0,
            line_level_discount_allocations: []
          });
          byIdentity[identity] = group;
          groups.push(group);
        }
        group._clyroLines.push(item);
        group.quantity += Number(item.quantity) || 0;
        group.final_line_price += Number(item.final_line_price) || 0;
        group.original_line_price += Number(item.original_line_price) || 0;
        group.line_price += Number(item.line_price) || 0;
        group.total_discount += Number(item.total_discount) || 0;
        (item.line_level_discount_allocations || []).forEach(function (allocation) {
          var title = allocation.discount_application && allocation.discount_application.title || '';
          var existing = group.line_level_discount_allocations.find(function (entry) {
            var entryTitle = entry.discount_application && entry.discount_application.title || '';
            return entryTitle === title;
          });
          if (existing) existing.amount += Number(allocation.amount) || 0;
          else group.line_level_discount_allocations.push({
            amount: Number(allocation.amount) || 0,
            discount_application: allocation.discount_application || null
          });
        });
      });
      return groups;
    }

    function quantityFeedback(item) {
      var note = lineFeedback[lineIdentity(item)];
      if (!note || note.quantity !== item.quantity || Date.now() - note.at > 60000) return '';
      return '<p data-cd-line-feedback role="status" aria-live="polite" style="margin:8px 0 0;font-size:13px;line-height:1.4;overflow-wrap:anywhere">' +
        escapeHTML(note.message) + '</p>';
    }

    function reportLine(item, message) {
      if (item) {
        lineFeedback[lineIdentity(item)] = { quantity: item.quantity, message: message, at: Date.now() };
        if (itemsHost && cart) itemsHost.innerHTML = cartRows(cart).map(itemHTML).join('');
        syncBusyControls();
      }
      showError(message);
      announce(message);
    }

    function matchingLine(data, before) {
      if (!before || !data || !Array.isArray(data.items)) return null;
      return cartRows(data).find(function (item) { return lineIdentity(item) === lineIdentity(before); }) || null;
    }

    function feedbackText(setting, fallback, item, error) {
      refreshConfig();
      var template = typeof config[setting] === 'string' && config[setting].trim() ? config[setting] : fallback;
      var values = {
        product: item && (item.product_title || item.title) || 'this tattoo',
        quantity: item ? String(item.quantity) : '',
        error: error || ''
      };
      // Single-pass replacement keeps tokens inside product/error text literal.
      return template.replace(/\[(product|quantity|error)\]/g, function (_, token) { return values[token]; });
    }

    function limitMessage(item) {
      // A purchase limit is not necessarily the store's total inventory.
      return item && item.quantity === 1
        ? feedbackText('stockSingleMessage', "You can currently buy only 1 of this tattoo, and it is already in your cart.", item)
        : feedbackText('stockLimitMessage', "You have reached the quantity currently available for this tattoo. Your cart shows the amount you can buy.", item);
    }

    function recoverQuantityCart() {
      if (window.clyroShop && window.clyroShop.refresh) return window.clyroShop.refresh({ throwOnError: true });
      // Refresh after rejection: Shopify can partially fulfill a quantity request.
      // Bound this read so a failed connection cannot lock the drawer indefinitely.
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer;
      var timeout = new Promise(function (_, reject) {
        timer = window.setTimeout(function () {
          if (controller) controller.abort();
          reject(new Error('Cart refresh timed out'));
        }, 12000);
      });
      var read = fetch(config.cartUrl, {
        credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart refresh failed');
        return response.json();
      }).then(function (data) {
        if (!data || !Array.isArray(data.items)) throw new Error('Invalid cart response');
        return data;
      });
      return Promise.race([read, timeout]).finally(function () { window.clearTimeout(timer); });
    }

    function itemHTML(item) {
      var rule = item._clyroLimit;
      var increment = rule ? rule.increment : 1;
      var nextQuantity = item.quantity + increment;
      var previousQuantity = item.quantity - increment;
      if (rule && previousQuantity < rule.min) previousQuantity = 0;
      var atLimit = rule && nextQuantity > rule.max;
      var image = item.image ? '<img src="' + escapeHTML(safeImage(item.image, 180)) + '" width="84" height="84" loading="lazy" alt="' + escapeHTML(item.product_title || '') + '">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div>' + escapeHTML(item.variant_title) + '</div>' : '';
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? '<div>' + escapeHTML(item.selling_plan_allocation.selling_plan.name) + '</div>' : '';
      var compare = Number(item.original_line_price) > Number(item.final_line_price) ? '<s>' + money(item.original_line_price) + '</s>' : '';
      var gift = item.properties && item.properties._clyro_gift ? '<div>' + escapeHTML(config.giftLabel || 'Gift') + '</div>' : '';
      return '<article class="clyro-cd-item" data-cd-line data-line-key="' + escapeHTML(item.key) + '" data-variant-id="' + escapeHTML(item.variant_id) + '">' +
        '<a class="clyro-cd-item__image" href="' + escapeHTML(item.url || '#') + '">' + image + '</a>' +
        '<div class="clyro-cd-item__body"><div class="clyro-cd-item__top">' +
          '<a class="clyro-cd-item__title" href="' + escapeHTML(item.url || '#') + '">' + escapeHTML(item.product_title || item.title || '') + '</a>' +
          '<button type="button" class="clyro-cd-item__remove" data-cd-remove data-key="' + escapeHTML(item.key) + '">' + escapeHTML(config.removeLabel || 'Remove') + '</button>' +
        '</div><div class="clyro-cd-item__meta">' + variant + plan + gift + '</div>' + itemProperties(item) +
        '<div class="clyro-cd-item__bottom"><div class="clyro-cd-qty" aria-label="' + escapeHTML(config.quantityLabel || 'Quantity') + '">' +
          '<button type="button" data-cd-quantity data-key="' + escapeHTML(item.key) + '" data-quantity="' + Math.max(0, previousQuantity) + '" aria-label="Decrease quantity">−</button>' +
          '<output aria-live="polite">' + escapeHTML(item.quantity) + '</output>' +
          '<button type="button" data-cd-quantity data-key="' + escapeHTML(item.key) + '" data-quantity="' + nextQuantity + '"' + (atLimit ? ' disabled data-cd-stock-disabled' : '') + ' aria-label="Increase quantity">+</button>' +
        '</div><div class="clyro-cd-item__price">' + compare + '<strong>' + money(item.final_line_price) + '</strong>' + itemDiscounts(item) + '</div></div>' + (atLimit ? '<p class="clyro-cd-item__feedback" role="status">' + escapeHTML(item.quantity > rule.max ? feedbackText('stockErrorMessage', '[error]', item, 'This quantity is no longer available. Reduce it or remove this tattoo before checkout.') : limitMessage(item)) + '</p>' : quantityFeedback(item)) + '</div></article>';
    }

    function renderRewards(data) {
      if (!rewardHost) return;
      var subtotal = qualifyingSubtotal(data);
      rewardHost.hidden = false;
      if (!rewards.length) {
        if (rewardCopy) rewardCopy.hidden = true;
        var emptyProgress = rewardHost.querySelector('.clyro-cd-progress');
        if (emptyProgress) emptyProgress.hidden = true;
        if (rewardLegend) rewardLegend.hidden = true;
        eligibleRewardCode = '';
        renderGiftClaim(data, subtotal);
        rewardHost.hidden = !giftHost || !giftHost.classList.contains('is-visible');
        return;
      }
      var highest = rewards[rewards.length - 1].threshold;
      var next = rewards.find(function (goal) { return subtotal < goal.threshold; });
      var reached = rewards.filter(function (goal) { return subtotal >= goal.threshold; });
      var latest = reached.length ? reached[reached.length - 1] : null;
      var reachedWithCode = reached.filter(function (goal) { return !!goal.code; });
      eligibleRewardCode = reachedWithCode.length ? reachedWithCode[reachedWithCode.length - 1].code : '';
      if (rewardCopy) rewardCopy.hidden = false;
      var shownProgress = rewardHost.querySelector('.clyro-cd-progress');
      if (shownProgress) shownProgress.hidden = false;
      var showLabels = rewardHost.getAttribute('data-show-labels') === 'true';
      var denseMilestones = showLabels && rewards.length > 2 && !!rewardLegend;
      var labelRowEnds = [];
      var labelLayout = rewards.map(function (goal) {
        var percent = clamp(goal.threshold / highest * 100, 0, 100);
        var row = 0;
        // Keep nearby conversion labels readable. The later milestone uses the
        // next row, so the final Free shipping label stays attached to its own
        // marker instead of being clamped into the preceding label.
        while (labelRowEnds[row] != null && percent - labelRowEnds[row] < 18) row += 1;
        labelRowEnds[row] = percent;
        return { percent: percent, row: row };
      });
      var staggeredMilestones = showLabels && !denseMilestones && labelLayout.some(function (layout) { return layout.row > 0; });
      rewardHost.setAttribute('data-dense-milestones', String(denseMilestones));
      rewardHost.setAttribute('data-staggered-milestones', String(staggeredMilestones));
      if (shownProgress) {
        if (staggeredMilestones) shownProgress.style.marginBottom = '68px';
        else shownProgress.style.removeProperty('margin-bottom');
      }
      if (rewardLegend) {
        rewardLegend.hidden = !denseMilestones;
        rewardLegend.innerHTML = denseMilestones ? rewards.map(function (goal) {
          return '<li class="' + (subtotal >= goal.threshold ? 'is-reached' : '') + '"><strong>' + escapeHTML(money(goal.threshold)) + '</strong><span>' + escapeHTML(goal.label || goal.reached || goal.kind) + '</span></li>';
        }).join('') : '';
      }
      var progress = rewardHost.querySelector('[role="progressbar"]');
      if (progress) {
        progress.setAttribute('aria-valuemin', '0');
        progress.setAttribute('aria-valuemax', String(highest));
        progress.setAttribute('aria-valuenow', String(Math.min(subtotal, highest)));
      }

      if (rewardCopy) {
        if (next) {
          var remaining = Math.max(0, next.threshold - subtotal);
          var message = (next.before || config.rewardHeading || 'Only [amount] away from your next reward').replace(/\[amount\]/g, money(remaining));
          rewardCopy.innerHTML = '<span>' + escapeHTML(message) + '</span><strong>' + escapeHTML(Math.round(clamp(subtotal / next.threshold, 0, 1) * 100)) + '%</strong>';
        } else {
          rewardCopy.innerHTML = '<strong>' + escapeHTML((latest && latest.reached) || config.rewardComplete || 'All rewards unlocked') + '</strong><span>✓</span>';
        }
      }
      if (rewardFill) rewardFill.style.width = (clamp(subtotal / highest, 0, 1) * 100) + '%';
      if (rewardMarkers) {
        rewardMarkers.innerHTML = rewards.map(function (goal, index) {
          var layout = labelLayout[index];
          var percent = layout.percent;
          var icon = goal.icon === 'auto' ? ({ shipping: 'truck', discount: 'percent', gift: 'gift' }[goal.kind] || 'star') : goal.icon;
          var paths = {
            truck: '<path d="M3 7h11v10H3zM14 10h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
            percent: '<circle cx="7" cy="7" r="2"/><circle cx="17" cy="17" r="2"/><path d="M18 5 6 19"/>',
            gift: '<path d="M4 10h16v11H4zM3 7h18v3H3zM12 7v14"/><path d="M12 7H8.5A2.5 2.5 0 1 1 11 4.5L12 7Zm0 0h3.5A2.5 2.5 0 1 0 13 4.5L12 7Z"/>',
            star: '<path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3l-5.6 2.9 1.1-6.2L3 9.6l6.2-.9L12 3Z"/>',
            check: '<path d="m5 12 5 5L20 7"/>'
          };
          var symbol = icon === 'custom' && goal.iconUrl ? '<img src="' + escapeHTML(goal.iconUrl) + '" alt="" loading="lazy">' : paths[icon] ? '<svg viewBox="0 0 24 24" aria-hidden="true">' + paths[icon] + '</svg>' : '';
          var labelTransform = percent >= 90 ? 'translateX(-100%)' : percent <= 10 ? 'translateX(0)' : 'translateX(-50%)';
          var labelAlign = percent >= 90 ? 'right' : percent <= 10 ? 'left' : 'center';
          var labelTop = 5 + layout.row * 24;
          var labelEdge = percent >= 90 ? 'end' : percent <= 10 ? 'start' : 'middle';
          var label = showLabels && !denseMilestones && goal.label ? '<span class="clyro-cd-progress__label" data-cd-milestone-label-row="' + layout.row + '" data-cd-milestone-edge="' + labelEdge + '" style="left:' + percent + '%;top:calc(50% + var(--cd-marker-size,28px) / 2 + ' + labelTop + 'px);width:max-content;max-width:none;white-space:nowrap;overflow-wrap:normal;transform:' + labelTransform + ';text-align:' + labelAlign + '">' + escapeHTML(goal.label) + '</span>' : '';
          return '<span class="clyro-cd-progress__marker' + (subtotal >= goal.threshold ? ' is-reached' : '') + '" style="left:' + percent + '%" title="' + escapeHTML(goal.label || goal.reached || goal.kind) + '">' + symbol + '</span>' + label;
        }).join('');
      }
      renderGiftClaim(data, subtotal);
    }

    function giftLine(data, gift) {
      return (data.items || []).find(function (item) {
        return item.properties && String(item.properties._clyro_gift) === String(gift.blockId);
      });
    }

    function renderGiftClaim(data, subtotal) {
      if (!giftHost || !gifts.length) return;
      var claimable = gifts.find(function (gift) {
        return subtotal >= gift.threshold && !giftLine(data, gift) && gift.mode !== 'auto';
      });
      if (!claimable) {
        giftHost.classList.remove('is-visible');
        giftHost.innerHTML = '';
        return;
      }
      giftHost.classList.add('is-visible');
      giftHost.innerHTML = (claimable.image ? '<img src="' + escapeHTML(safeImage(claimable.image, 96)) + '" width="48" height="48" loading="lazy" alt="">' : '') +
        '<div class="clyro-cd-gift__copy"><strong>' + escapeHTML(claimable.title) + '</strong><span>' + escapeHTML(claimable.message || config.giftUnlockedLabel || 'Your gift is unlocked') + '</span></div>' +
        '<button type="button" class="clyro-cd-gift__claim" data-cd-claim-gift data-block-id="' + escapeHTML(claimable.blockId) + '">' + escapeHTML(config.giftClaimLabel || 'Add gift') + '</button>';
    }

    function reconcileAutoGifts(data) {
      if (giftSyncing || checkoutPending || checkoutStarted || !gifts.length || !data) return;
      var subtotal = qualifyingSubtotal(data);
      var action = null;
      gifts.some(function (gift) {
        var line = giftLine(data, gift);
        if (gift.mode === 'auto' && subtotal >= gift.threshold && !line) {
          action = { type: 'add', gift: gift };
          return true;
        }
        if (gift.removeBelow && subtotal < gift.threshold && line) {
          action = { type: 'remove', gift: gift, line: line };
          return true;
        }
        return false;
      });
      if (!action || busy) return;
      var signature = JSON.stringify([action.type, action.gift.blockId, data.total_price, data.items.map(function (line) { return [line.key, line.quantity]; })]);
      if (signature === giftAttemptSignature) return;
      giftAttemptSignature = signature;
      giftSyncing = true;
      var promise = action.type === 'add' ? addGift(action.gift, false) : changeLine(action.line.key, 0, false);
      Promise.resolve(promise).then(function (result) {
        giftSyncing = false;
        if (result) window.setTimeout(function () { reconcileAutoGifts(cart); }, 0);
      }, function () { giftSyncing = false; });
    }

    function renderAddons(data) {
      var nodes = root.querySelectorAll('[data-cd-addon]');
      for (var i = 0; i < nodes.length; i += 1) {
        var node = nodes[i];
        var variantId = Number(node.getAttribute('data-variant-id')) || 0;
        var button = node.querySelector('[data-cd-addon-toggle]');
        var line = (data.items || []).find(function (item) {
          return Number(item.variant_id) === variantId && item.properties &&
            String(item.properties._clyro_addon) === String(node.getAttribute('data-block-id'));
        });
        node.setAttribute('data-line-key', line ? line.key : '');
        if (button) {
          button.setAttribute('aria-pressed', line ? 'true' : 'false');
          button.setAttribute('aria-label', (line ? config.removeAddonLabel : config.addAddonLabel) || (line ? 'Remove add-on' : 'Add add-on'));
        }
      }
    }

    function upsellCards() {
      return upsellHost ? Array.prototype.filter.call(upsellHost.children, function (node) {
        return node.hasAttribute('data-cd-upsell-card');
      }) : [];
    }

    function upsellPosition(node) {
      if (!upsellHost || !node) return 0;
      var hostRect = upsellHost.getBoundingClientRect();
      var nodeRect = node.getBoundingClientRect();
      return upsellHost.scrollLeft + nodeRect.left - hostRect.left - upsellHost.clientLeft;
    }

    function removeUpsellClones() {
      if (!upsellHost) return;
      var clones = upsellHost.querySelectorAll('[data-cd-upsell-clone]');
      for (var i = 0; i < clones.length; i += 1) clones[i].remove();
      upsellWrapTarget = null;
      upsellWrapClone = null;
      upsellNavigationBusy = false;
    }

    function addUpsellClone(card, position) {
      var clone = card.cloneNode(true);
      clone.removeAttribute('data-cd-upsell-card');
      clone.removeAttribute('data-product-id');
      clone.setAttribute('data-cd-upsell-clone', position);
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      if (position === 'before') upsellHost.insertBefore(clone, upsellHost.firstChild);
      else upsellHost.appendChild(clone);
      return clone;
    }

    function ensureUpsellClones() {
      if (!upsellHost || config.upsellLoop !== true) return;
      var cards = upsellCards();
      if (cards.length < 2 || upsellHost.querySelector('[data-cd-upsell-clone]')) return;
      addUpsellClone(cards[cards.length - 1], 'before');
      var firstClone = addUpsellClone(cards[0], 'after');
      // Start on the first real card, with a matching clone on either end.
      upsellHost.scrollLeft = upsellPosition(cards[0]);
      firstClone.setAttribute('data-cd-upsell-clone', 'after');
    }

    function currentUpsellIndex(cards) {
      if (!cards.length) return 0;
      var edge = upsellHost.getBoundingClientRect().left + upsellHost.clientLeft;
      var nearest = 0;
      var distance = Infinity;
      for (var i = 0; i < cards.length; i += 1) {
        var candidate = Math.abs(cards[i].getBoundingClientRect().left - edge);
        if (candidate < distance) { distance = candidate; nearest = i; }
      }
      return nearest;
    }

    function refreshUpsellControls() {
      if (!upsellHost || !upsellControls) return;
      var cards = upsellCards();
      var active = config.upsellDisplayMode === 'carousel' && cards.length > 1;
      upsellControls.hidden = !active;
      var previous = upsellControls.querySelector('[data-cd-upsell-previous]');
      var next = upsellControls.querySelector('[data-cd-upsell-next]');
      var current = currentUpsellIndex(cards);
      var looping = config.upsellLoop === true;
      if (previous) previous.disabled = !active || upsellNavigationBusy || (!looping && current <= 0);
      if (next) next.disabled = !active || upsellNavigationBusy || (!looping && current >= cards.length - 1);
    }

    function clearUpsellAutoplay() {
      window.clearTimeout(upsellAutoplayTimer);
      upsellAutoplayTimer = 0;
    }

    function scheduleUpsellAutoplay(delay) {
      clearUpsellAutoplay();
      if (!upsellHost || !isOpen || config.upsellDisplayMode !== 'carousel' ||
          config.upsellAutoplay !== true || upsellCards().length < 2 ||
          (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
      upsellAutoplayTimer = window.setTimeout(function () {
        upsellAutoplayTimer = 0;
        var controlsFocused = upsellControls && upsellControls.contains(document.activeElement);
        if (!isOpen || document.hidden || upsellHost.matches(':hover') ||
            upsellHost.contains(document.activeElement) || controlsFocused) {
          scheduleUpsellAutoplay(1500);
          return;
        }
        if (!moveUpsellCarousel(1, true)) clearUpsellAutoplay();
      }, delay || Math.max(3000, Number(config.upsellAutoplayInterval) || 5000));
    }

    function finishUpsellScroll() {
      if (!upsellHost) return;
      window.clearTimeout(upsellScrollTimer);
      upsellScrollTimer = 0;
      var cards = upsellCards();
      var target = upsellWrapTarget;
      var before = upsellHost.querySelector('[data-cd-upsell-clone="before"]');
      var after = upsellHost.querySelector('[data-cd-upsell-clone="after"]');
      var max = Math.max(0, upsellHost.scrollWidth - upsellHost.clientWidth);
      var afterIsVisibleAtEnd = !!after && upsellHost.scrollLeft >= max - 3 &&
        Math.abs(upsellPosition(after) - upsellHost.scrollLeft) <=
          Math.max(3, upsellHost.clientWidth - after.getBoundingClientRect().width + 3);
      var beforeIsAligned = !!before && Math.abs(upsellPosition(before) - upsellHost.scrollLeft) < 3;
      var afterIsAligned = !!after && Math.abs(upsellPosition(after) - upsellHost.scrollLeft) < 3;
      if (target !== null) {
        // A touch gesture can interrupt an arrow animation. Only perform the
        // invisible wrap if the matching edge clone was actually reached.
        if ((upsellWrapClone === 'before' && !beforeIsAligned) ||
            (upsellWrapClone === 'after' && !afterIsAligned && !afterIsVisibleAtEnd)) target = null;
      }
      if (target === null && config.upsellLoop === true) {
        // Touch/trackpad users can reach the end clones too; wrap them just like arrow users.
        if (beforeIsAligned) target = cards.length - 1;
        else if (afterIsAligned || afterIsVisibleAtEnd) target = 0;
      }
      if (target !== null && cards[target]) upsellHost.scrollLeft = upsellPosition(cards[target]);
      upsellWrapTarget = null;
      upsellWrapClone = null;
      upsellNavigationBusy = false;
      refreshUpsellControls();
      scheduleUpsellAutoplay();
    }

    function scheduleUpsellScrollFinish() {
      window.clearTimeout(upsellScrollTimer);
      upsellScrollTimer = window.setTimeout(finishUpsellScroll, 650);
    }

    function scrollUpsellsTo(left, smooth) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      upsellHost.scrollTo({ left: left, behavior: smooth && !reduced ? 'smooth' : 'auto' });
      scheduleUpsellScrollFinish();
    }

    function moveUpsellCarousel(direction, automatic) {
      if (!upsellHost || config.upsellDisplayMode !== 'carousel' || upsellNavigationBusy) return false;
      var cards = upsellCards();
      if (cards.length < 2) return false;
      var current = currentUpsellIndex(cards);
      var target = current + direction;
      var looping = config.upsellLoop === true;
      clearUpsellAutoplay();
      if (target >= 0 && target < cards.length) {
        upsellNavigationBusy = true;
        scrollUpsellsTo(upsellPosition(cards[target]), true);
      } else if (looping) {
        ensureUpsellClones();
        var clone = upsellHost.querySelector(direction > 0 ? '[data-cd-upsell-clone="after"]' : '[data-cd-upsell-clone="before"]');
        if (!clone) return false;
        upsellNavigationBusy = true;
        upsellWrapTarget = direction > 0 ? 0 : cards.length - 1;
        upsellWrapClone = direction > 0 ? 'after' : 'before';
        scrollUpsellsTo(upsellPosition(clone), true);
      } else {
        refreshUpsellControls();
        return false;
      }
      refreshUpsellControls();
      return true;
    }

    function syncUpsellPresentation() {
      if (!upsellHost) return;
      clearUpsellAutoplay();
      window.clearTimeout(upsellScrollTimer);
      upsellScrollTimer = 0;
      removeUpsellClones();
      var carousel = config.upsellDisplayMode === 'carousel';
      upsellHost.classList.toggle('is-carousel', carousel);
      if (!carousel) upsellHost.scrollLeft = 0;
      else ensureUpsellClones();
      if (!upsellScrollHandler) {
        upsellScrollHandler = function () {
          clearUpsellAutoplay();
          refreshUpsellControls();
          scheduleUpsellScrollFinish();
        };
        upsellHost.addEventListener('scroll', upsellScrollHandler, { passive: true });
      }
      refreshUpsellControls();
      scheduleUpsellAutoplay();
    }

    function cloneStaticUpsells(data) {
      if (!upsellHost) return;
      var source = config.upsellSource || 'manual';
      var templates = root.querySelectorAll('[data-cd-upsell-template][data-source="' + source + '"]');
      var cartProductIds = (data.items || []).map(function (item) { return String(item.product_id); });
      var shown = 0;
      upsellHost.innerHTML = '';
      for (var i = 0; i < templates.length && shown < Number(config.upsellLimit || 4); i += 1) {
        var template = templates[i];
        if (config.hideProductsInCart && cartProductIds.indexOf(template.getAttribute('data-product-id')) !== -1) continue;
        var card = template.content.firstElementChild.cloneNode(true);
        upsellHost.appendChild(card);
        shown += 1;
      }
      var section = upsellHost.closest('[data-cd-upsell-section]');
      if (section) section.hidden = shown === 0;
      syncUpsellPresentation();
    }

    function recommendationCard(product) {
      var variants = product.variants || [];
      var selected = variants.find(function (variant) { return variant.available; }) || variants[0];
      if (!selected) return '';
      var image = product.featured_image && (product.featured_image.url || product.featured_image.src || product.featured_image);
      var compare = Number(selected.compare_at_price) > Number(selected.price) ? '<s>' + money(selected.compare_at_price) + '</s>' : '';
      var select = variants.length > 1 ? '<label class="clyro-cd-sr-only">Choose an option for ' + escapeHTML(product.title) + '</label><select class="clyro-cd-upsell__select" data-cd-upsell-variant>' + variants.map(function (variant) {
        return '<option value="' + escapeHTML(variant.id) + '" data-price="' + escapeHTML(variant.price) + '" data-compare="' + escapeHTML(variant.compare_at_price || 0) + '"' + (variant.available ? '' : ' disabled') + (String(variant.id) === String(selected.id) ? ' selected' : '') + '>' + escapeHTML(variant.title) + (variant.available ? '' : ' — Sold out') + '</option>';
      }).join('') + '</select>' : '';
      return '<article class="clyro-cd-upsell" data-cd-upsell-card data-product-id="' + escapeHTML(product.id) + '">' +
        '<a class="clyro-cd-upsell__image" href="' + escapeHTML(product.url || '#') + '" tabindex="-1" aria-hidden="true">' + (image ? '<img src="' + escapeHTML(safeImage(image, 240)) + '" width="84" height="84" loading="lazy" alt="">' : '') + '</a>' +
        '<div class="clyro-cd-upsell__body"><a class="clyro-cd-upsell__title" href="' + escapeHTML(product.url || '#') + '">' + escapeHTML(product.title) + '</a>' +
        '<div class="clyro-cd-upsell__price" data-cd-upsell-price>' + compare + '<strong>' + money(selected.price) + '</strong></div>' + select +
        '<button type="button" class="clyro-cd-upsell__add" data-cd-upsell-add data-variant-id="' + escapeHTML(selected.id) + '"' + (selected.available ? '' : ' disabled') + '><span data-cd-button-label>' + escapeHTML(config.upsellButtonLabel || 'Add') + '</span><span class="clyro-cd-button-spinner" aria-hidden="true"></span></button></div></article>';
    }

    function loadRecommendations(data) {
      if (!upsellHost) return;
      var first = (data.items || []).find(function (item) { return !(item.properties && item.properties._clyro_gift); });
      var section = upsellHost.closest('[data-cd-upsell-section]');
      if (!first) {
        if (section) section.hidden = true;
        return;
      }
      if (recommendationsFor === String(first.product_id) && upsellHost.children.length) return;
      recommendationsFor = String(first.product_id);
      if (section) section.hidden = false;
      if (upsellLoading) upsellLoading.hidden = false;
      var endpoint = config.recommendationsUrl + '.json?product_id=' + encodeURIComponent(first.product_id) + '&limit=' + encodeURIComponent(config.upsellLimit || 4) + '&intent=related';
      fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('Recommendations unavailable')); })
        .then(function (payload) {
          var cartProductIds = (data.items || []).map(function (item) { return String(item.product_id); });
          var products = (payload.products || []).filter(function (product) {
            return !config.hideProductsInCart || cartProductIds.indexOf(String(product.id)) === -1;
          }).slice(0, Number(config.upsellLimit || 4));
          upsellHost.innerHTML = products.map(recommendationCard).join('');
          if (section) section.hidden = products.length === 0;
          syncUpsellPresentation();
        }).catch(function () {
          recommendationsFor = '';
          if (section) section.hidden = true;
        }).finally(function () { if (upsellLoading) upsellLoading.hidden = true; });
    }

    function renderUpsells(data) {
      if (!upsellHost || config.showUpsells === false) return;
      if (config.upsellSource === 'recommendations') loadRecommendations(data);
      else cloneStaticUpsells(data);
    }

    function render(data) {
      if (data && data._clyroRevision && data._clyroRevision < renderedRevision) return;
      if (data && data._clyroRevision) renderedRevision = data._clyroRevision;
      if (destroyed || !data || !Array.isArray(data.items)) return;
      refreshConfig();
      cart = data;
      var rows = cartRows(data);
      Object.keys(lineFeedback).forEach(function (identity) {
        var note = lineFeedback[identity];
        var line = rows.find(function (item) { return lineIdentity(item) === identity; });
        if (!line || line.quantity !== note.quantity || Date.now() - note.at > 60000) delete lineFeedback[identity];
      });
      // Passive refreshes must not erase a Shopify rejection arriving during
      // initial load. Only the next explicit mutation/success clears feedback.
      syncGlobalCount(data.item_count);
      for (var i = 0; i < countNodes.length; i += 1) countNodes[i].textContent = String(data.item_count);
      for (var f = 0; f < floatingCount.length; f += 1) floatingCount[f].textContent = String(data.item_count);

      var hasItems = data.item_count > 0;
      if (itemsHost) {
        itemsHost.hidden = !hasItems;
        itemsHost.innerHTML = hasItems ? rows.map(itemHTML).join('') : '';
      }
      if (emptyHost) emptyHost.hidden = hasItems;
      if (!hasItems) stopTimer(true);
      else if (isOpen) startTimer();
      if (subtotalNode) subtotalNode.textContent = summaryMoney(data.total_price);
      if (checkoutButton) checkoutButton.disabled = !hasItems || checkoutPending || checkoutStarted;
      if (noteInput && document.activeElement !== noteInput) noteInput.value = data.note || '';

      var discount = cartDiscount(data);
      var showInlineSavings = hasItems && config.showSubtotalSavings === true && discount > 0;
      if (inlineSavingsNode) {
        inlineSavingsNode.hidden = !showInlineSavings;
        if (showInlineSavings) {
          var amount = savingsMoney(discount);
          var template = config.subtotalSavingsLabel || 'Save [amount]';
          inlineSavingsNode.textContent = savingsText(template, amount);
        } else inlineSavingsNode.textContent = '';
      }
      if (originalSubtotalNode) {
        originalSubtotalNode.hidden = !hasItems || !discount || config.showOriginalSubtotal === false ||
          (!showInlineSavings && config.showOriginalWithoutSavings !== true);
        if (!originalSubtotalNode.hidden) {
          var originalTotal = Number(data.original_total_price);
          originalSubtotalNode.textContent = originalMoney(Number.isFinite(originalTotal) && originalTotal > Number(data.total_price) ? originalTotal : Number(data.total_price) + discount);
        } else originalSubtotalNode.textContent = '';
      }
      if (savingsNode) {
        savingsNode.hidden = discount <= 0 || (showInlineSavings && config.showBothSavingsLines !== true) || config.showSavingsLine === false;
        savingsNode.textContent = savingsNode.hidden ? '' : savingsText(config.savingsLabel, savingsMoney(discount));
      }
      renderRewards(data);
      var addonSection = root.querySelector('[data-cd-addon-section]');
      var upsellSection = root.querySelector('[data-cd-upsell-section]');
      if (addonSection) addonSection.hidden = !hasItems;
      if (hasItems) {
        renderAddons(data);
        renderUpsells(data);
      } else if (upsellSection) {
        upsellSection.hidden = true;
      }
      window.setTimeout(function () { if (!destroyed) reconcileAutoGifts(cart); }, 0);
      announce((config.cartUpdatedLabel || 'Cart updated') + ': ' + data.item_count);
      syncBusyControls();
      updateShipping();
    }

    function changeLine(key, quantity, speak) {
      if (busy || checkoutPending || checkoutStarted || !key) return Promise.resolve(null);
      var before = cart && cartRows(cart).find(function (item) {
        return item.key === key || (item._clyroLines || []).some(function (line) { return line.key === key; });
      });
      if (before && before._clyroLimit && quantity > before._clyroLimit.max && quantity >= before.quantity) {
        reportLine(before, limitMessage(before));
        return Promise.resolve(null);
      }
      if (before) delete lineFeedback[lineIdentity(before)];
      setBusy(true);
      showError('');
      function postChange(lineKey, lineQuantity) {
        if (window.clyroShop && window.clyroShop.change) return window.clyroShop.change(lineKey, lineQuantity);
        return fetch(config.changeUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: lineKey, quantity: lineQuantity })
        }).then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status >= 400) {
              var error = new Error(data.description || data.message || config.errorMessage || 'The cart could not be updated.');
              error.status = response.status;
              throw error;
            }
            return data;
          });
        });
      }
      function decreaseTo(data, target, depth) {
        var group = matchingLine(data, before);
        if (!group || group.quantity <= target || depth > 8) return Promise.resolve(data);
        var lines = group._clyroLines || [group];
        var line = lines[lines.length - 1];
        var remove = Math.min(group.quantity - target, Number(line.quantity) || 0);
        return postChange(line.key, Math.max(0, Number(line.quantity) - remove)).then(function (next) {
          if (!next || !Array.isArray(next.items)) return recoverQuantityCart();
          return decreaseTo(next, target, depth + 1);
        });
      }
      var request = Promise.resolve().then(function () {
        if (!before) throw new Error('This cart item changed. Please try again.');
        if (quantity > before.quantity) {
          var sourceLines = before._clyroLines || [before];
          // A normal cart row should use change.js so Shopify can return its
          // authoritative inventory response. Only add the delta when an
          // automatic discount has split one visible product across lines.
          if (sourceLines.length === 1) return postChange(sourceLines[0].key, quantity);
          var addQuantity = quantity - before.quantity;
          var plan = before.selling_plan_allocation && before.selling_plan_allocation.selling_plan;
          if (window.clyroShop && window.clyroShop.add) {
            return window.clyroShop.add(before.variant_id || before.id, addQuantity, plan && plan.id, {
              properties: before.properties || {}, source: 'cart_quantity', open: false, throwOnError: true
            }).then(function () {
              return window.clyroShop.refresh({ throwOnError: true });
            });
          }
          var addLine = { id: before.variant_id || before.id, quantity: addQuantity };
          if (plan && plan.id) addLine.selling_plan = plan.id;
          if (before.properties && Object.keys(before.properties).length) addLine.properties = before.properties;
          return fetch(config.addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [addLine] })
          }).then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || config.errorMessage);
              return recoverQuantityCart();
            });
          });
        }
        return decreaseTo(cart, Math.max(0, quantity), 0);
      });
      return request.then(function (data) {
        if (!data || !Array.isArray(data.items)) throw new Error(config.errorMessage || 'The cart could not be updated.');
        render(data);
        var actual = matchingLine(data, before);
        if (quantity > 0 && (!actual || actual.quantity !== quantity)) {
          reportLine(actual, feedbackText('stockAdjustedMessage', "The requested quantity could not be added. Your cart now shows the quantity Shopify allows for this tattoo.", actual));
        } else if (speak !== false) announce(config.cartUpdatedLabel || 'Cart updated');
        return data;
      }).catch(function (error) {
        cartFailure += 1;
        var reason = error.message || config.errorMessage || 'The quantity could not be updated.';
        return recoverQuantityCart().then(function (fresh) {
          render(fresh);
          var actual = matchingLine(fresh, before);
          var maximum = /maximum quantity.*already in your cart/i.test(reason);
          var inventory = /stock|inventory|available quantity|due to availability|sold out|can't add more|cannot add more/i.test(reason);
          var message = maximum && actual ? limitMessage(actual) :
            inventory ? feedbackText('stockErrorMessage', '[error] Your cart has been refreshed to show the current quantity.', actual, reason) :
              feedbackText('quantityErrorMessage', '[error]', actual, reason);
          reportLine(actual, message);
          return null;
        }).catch(function () {
          reportLine(before, feedbackText('stockRefreshError', '[error] We could not refresh your cart. Check your connection and refresh before trying again.', before, reason));
          return null;
        });
      }).finally(function () { setBusy(false); });
    }

    function addWithProperties(variantId, properties, source) {
      if (busy || checkoutPending || checkoutStarted || !variantId) return Promise.resolve(null);
      setBusy(true);
      showError('');
      if (!window.clyroShop || !window.clyroShop.add) {
        setBusy(false); showError(config.errorMessage); return Promise.resolve(null);
      }
      return window.clyroShop.add(variantId, 1, null, {
        properties: properties || {}, source: source || 'cart_drawer', open: false, throwOnError: true
      }).then(function () {
        track('cart_add', { source: source || 'cart_drawer', variant_id: Number(variantId) });
        return cart;
      }).catch(function (error) {
        cartFailure += 1; showError(error.message || config.addErrorMessage); return null;
      }).finally(function () { setBusy(false); });
    }

    function addGift(gift, speak) {
      if (!gift) return Promise.resolve(null);
      return addWithProperties(gift.variantId, {
        _clyro_gift: gift.blockId,
        _clyro_gift_label: gift.title
      }, 'cart_gift').then(function (data) {
        if (data && speak !== false) announce(config.giftAddedLabel || 'Gift added');
        return data;
      });
    }

    function saveNote() {
      window.clearTimeout(noteHandle); noteHandle = null;
      if (!noteInput || !window.clyroShop || !window.clyroShop.update) return noteRequest;
      var value = noteInput.value || '';
      setBusy(true);
      noteRequest = window.clyroShop.update({ note: value }).catch(function (error) {
        cartFailure += 1; showError(error.message || config.errorMessage);
      }).finally(function () { setBusy(false); });
      return noteRequest;
    }
    function updateNote() {
      if (!noteInput) return;
      window.clearTimeout(noteHandle);
      noteHandle = window.setTimeout(saveNote, 450);
    }

    function checkout() {
      if (checkoutPending || checkoutStarted || !checkoutButton) return;
      if (termsInput && !termsInput.checked) {
        showError(config.termsError || 'Please accept the terms before checkout.');
        termsInput.focus(); return;
      }
      var attempt = ++checkoutAttempt;
      var failure = cartFailure;
      checkoutPending = true;
      syncBusyControls();
      checkoutButton.classList.add('is-loading');
      checkoutButton.disabled = true;
      if (noteHandle) saveNote();
      if (window.clyroShop && window.clyroShop.lockCheckout) window.clyroShop.lockCheckout(true);
      var globalIdle = window.clyroShop && window.clyroShop.whenIdle ? window.clyroShop.whenIdle() : Promise.resolve();
      // Keep the first click; wait for accepted cart writes instead of dropping it.
      Promise.all([globalIdle, localIdle(), noteRequest]).then(function () {
        if (attempt !== checkoutAttempt || destroyed || failure !== cartFailure) return null;
        // Read the server cart after all writes, before leaving for checkout.
        if (window.clyroShop && window.clyroShop.refresh) return window.clyroShop.refresh({ throwOnError: true });
        return fetch(config.cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
          .then(function (response) { if (!response.ok) throw new Error(config.errorMessage); return response.json(); });
      }).then(function (freshCart) {
        if (attempt !== checkoutAttempt || destroyed) return;
        if (failure !== cartFailure) { cancelCheckout(); return; }
        if (!freshCart || !Array.isArray(freshCart.items)) { cancelCheckout(); showError('Your cart could not be verified. Please try again.'); return; }
        render(freshCart);
        if (!cart || !cart.item_count) { cancelCheckout(); showError('Your cart is empty. Add an item before checkout.'); return; }
        var invalid = cartRows(cart).find(function (item) {
          var rule = item._clyroLimit;
          // A missing optional section is not proof that an item is unavailable.
          // Shopify checkout remains the final inventory and delivery authority.
          return rule && (item.quantity > rule.max || item.quantity < rule.min || item.quantity % rule.increment !== 0);
        });
        if (invalid) {
          cancelCheckout();
          reportLine(invalid, feedbackText('stockErrorMessage', '[error]', invalid, 'Check the available quantity for this tattoo. Reduce it or remove it before checkout.'));
          return;
        }
        if (termsInput && !termsInput.checked) { cancelCheckout(); showError(config.termsError); return; }
        var code = (pendingDiscount || eligibleRewardCode || '').trim();
        if (code && window.clyroShop && window.clyroShop.applyDiscountForCheckout) {
          return window.clyroShop.applyDiscountForCheckout(code).then(function (discountedCart) {
            if (attempt !== checkoutAttempt || destroyed) return;
            if (discountedCart) { cart = discountedCart; render(discountedCart); }
            if (pendingDiscount) {
              pendingDiscount = '';
              pendingDiscountAt = 0;
              try {
                window.sessionStorage.removeItem('clyro:discount-code');
                window.sessionStorage.removeItem('clyro:discount-code-at');
              } catch (_) {}
            }
            navigateCheckout();
          });
        }
        navigateCheckout();
      }).catch(function (error) {
        if (attempt !== checkoutAttempt || destroyed) return;
        cancelCheckout(); showError(error.message || config.errorMessage);
      });
      window.setTimeout(function () {
        if (attempt === checkoutAttempt && checkoutPending && !checkoutStarted) {
          cancelCheckout();
          showError('The cart is taking too long to update. Please try checkout again.');
        }
      }, 12000);
    }
    function navigateCheckout() {
      showError('');
      checkoutStarted = true;
      checkoutPending = false;
      stopTimer(true);
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      routeRoot = routeRoot.replace(/\/?$/, '/');
      var checkoutUrl = config.checkoutUrl || routeRoot + 'checkout';
      track('begin_checkout', {
        currency: config.currency,
        value: Number(cart.total_price || 0) / 100,
        items: cart.items.map(function (item) { return { item_id: String(item.product_id), item_variant: String(item.variant_id), quantity: item.quantity, price: Number(item.final_price || 0) / 100 }; })
      });
      // Record a one-time return target immediately before the single checkout
      // navigation. Ordinary visits, reloads and unrelated Back navigation do
      // not receive this signal.
      try { document.dispatchEvent(new CustomEvent('clyro:checkout-started', { detail: { source: 'native-cart-drawer' } })); } catch (_) {}
      // Do not re-click a disabled button/anchor or dispatch another checkout
      // event. This single same-tab navigation also supports older button markup.
      try {
        var departureFrom = window.location.href;
        window.location.assign(checkoutUrl);
        window.setTimeout(function () {
          // location.assign does not throw when a browser extension or another
          // script cancels navigation. Release the session instead of leaving
          // checkout and add-to-cart controls locked indefinitely.
          if (checkoutStarted && document.visibilityState !== 'hidden' && window.location.href === departureFrom) {
            checkoutStarted = false;
            cancelCheckout();
            showError('Checkout did not open. Please try again.');
          }
        }, 4000);
      } catch (error) {
        checkoutStarted = false;
        cancelCheckout();
        showError(error.message || 'Checkout could not open. Please try again.');
      }
    }

    // Prevent the original default action; navigateCheckout owns navigation.
    function onCheckoutClick(event) {
      var control = event.target.closest('[data-cd-checkout],[data-cd-expiry-checkout]');
      if (!control) return;
      event.stopImmediatePropagation();
      event.preventDefault();
      if (expiryClearing) return;
      if (expiryModal) expiryModal.hidden = true;
      checkout();
    }
    root.addEventListener('click', onCheckoutClick, true);

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-cd-expiry-keep]')) {
        event.preventDefault();
        if (expiryClearing) return;
        resetTimer();
        return;
      }
      var close = event.target.closest('[data-cd-close]');
      if (close) {
        if (close.tagName !== 'A') event.preventDefault();
        closeDrawer('user');
        return;
      }

      var upsellPrevious = event.target.closest('[data-cd-upsell-previous]');
      if (upsellPrevious) { event.preventDefault(); moveUpsellCarousel(-1); return; }
      var upsellNext = event.target.closest('[data-cd-upsell-next]');
      if (upsellNext) { event.preventDefault(); moveUpsellCarousel(1); return; }

      var quantity = event.target.closest('[data-cd-quantity]');
      if (quantity) {
        event.preventDefault();
        changeLine(quantity.getAttribute('data-key'), Number(quantity.getAttribute('data-quantity')) || 0);
        return;
      }
      var remove = event.target.closest('[data-cd-remove]');
      if (remove) { event.preventDefault(); changeLine(remove.getAttribute('data-key'), 0); return; }

      var add = event.target.closest('[data-cd-upsell-add]');
      if (add) {
        event.preventDefault();
        if (checkoutPending || checkoutStarted || add.disabled || add.classList.contains('is-loading')) return;
        var card = add.closest('[data-cd-upsell-card]');
        var select = card && card.querySelector('[data-cd-upsell-variant]');
        var variantId = select ? select.value : add.getAttribute('data-variant-id');
        add.classList.add('is-loading');
        add.disabled = true;
        var request = window.clyroShop && window.clyroShop.add ? window.clyroShop.add(variantId, 1) : addWithProperties(variantId, {}, 'cart_upsell');
        Promise.resolve(request).then(function (result) {
          if (!result) throw new Error(config.addErrorMessage || 'Unable to add this item.');
          track('cart_upsell_add', { product_id: card && card.getAttribute('data-product-id'), variant_id: String(variantId) });
        }).catch(function (error) {
          showError(error.message || config.addErrorMessage);
        }).finally(function () {
          add.classList.remove('is-loading');
          add.disabled = false;
        });
        return;
      }

      var addon = event.target.closest('[data-cd-addon-toggle]');
      if (addon) {
        event.preventDefault();
        var addonRow = addon.closest('[data-cd-addon]');
        var lineKey = addonRow.getAttribute('data-line-key');
        if (lineKey) changeLine(lineKey, 0);
        else addWithProperties(addonRow.getAttribute('data-variant-id'), { _clyro_addon: addonRow.getAttribute('data-block-id') || 'addon' }, 'cart_addon');
        return;
      }

      var giftButton = event.target.closest('[data-cd-claim-gift]');
      if (giftButton) {
        event.preventDefault();
        var gift = gifts.find(function (entry) { return entry.blockId === giftButton.getAttribute('data-block-id'); });
        addGift(gift, true);
        return;
      }

      var applyDiscount = event.target.closest('[data-cd-apply-discount]');
      if (applyDiscount) {
        event.preventDefault();
        pendingDiscount = discountInput ? discountInput.value.trim() : '';
        pendingDiscountAt = pendingDiscount ? Date.now() : 0;
        try {
          if (pendingDiscount) {
            window.sessionStorage.setItem('clyro:discount-code', pendingDiscount);
            window.sessionStorage.setItem('clyro:discount-code-at', String(pendingDiscountAt));
          } else {
            window.sessionStorage.removeItem('clyro:discount-code');
            window.sessionStorage.removeItem('clyro:discount-code-at');
          }
        } catch (_) {}
        if (discountStatus) discountStatus.textContent = pendingDiscount ? (config.discountSaved || 'Code saved. It will be verified at checkout.') : '';
        return;
      }

    });

    root.addEventListener('change', function (event) {
      var select = event.target.closest('[data-cd-upsell-variant]');
      if (!select) return;
      var card = select.closest('[data-cd-upsell-card]');
      var add = card && card.querySelector('[data-cd-upsell-add]');
      var price = card && card.querySelector('[data-cd-upsell-price]');
      var option = select.options[select.selectedIndex];
      if (add) add.setAttribute('data-variant-id', option.value);
      if (price) {
        var compare = Number(option.getAttribute('data-compare')) || 0;
        var current = Number(option.getAttribute('data-price')) || 0;
        price.innerHTML = (compare > current ? '<s>' + money(compare) + '</s>' : '') + '<strong>' + money(current) + '</strong>';
      }
    });

    if (noteInput) noteInput.addEventListener('input', updateNote);
    if (discountInput) {
      try {
        pendingDiscountAt = Number(window.sessionStorage.getItem('clyro:discount-code-at')) || 0;
        // Legacy entries had no timestamp and could survive old test sessions.
        // Keep only codes explicitly entered during the last two hours.
        if (pendingDiscountAt && Date.now() - pendingDiscountAt < 7200000) {
          pendingDiscount = window.sessionStorage.getItem('clyro:discount-code') || '';
        } else {
          pendingDiscount = '';
          pendingDiscountAt = 0;
          window.sessionStorage.removeItem('clyro:discount-code');
          window.sessionStorage.removeItem('clyro:discount-code-at');
        }
        discountInput.value = pendingDiscount;
      } catch (_) {}
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); closeDrawer('user'); return; }
      if (event.key !== 'Tab' || !isOpen) return;
      var focusScope = expiryModal && !expiryModal.hidden ? expiryModal : panel;
      var focusable = focusScope.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    function onExternalOpen(event) {
      var detail = event.detail || {};
      if (detail.source !== 'header-cart' || !detail.userEvent || detail.userEvent.isTrusted !== true) return;
      openDrawer({ source: 'header-cart', refresh: true });
      detail.accepted = isOpen && !destroyed && root.isConnected !== false && root.hidden === false;
    }
    function onExternalClose() {
      closeDrawer('user');
    }
    function onCartAdded(event) {
      var detail = event.detail || {};
      // Only the purchase module's confirmed POST completion can open.
      if (detail.success !== true || !detail.operationId || handledAdds.has(detail.operationId)) return;
      detail.accepted = true;
      showError('');
      handledAdds.add(detail.operationId);
      if (detail.cart) render(detail.cart);
      var alreadyOpen = isOpen;
      if (cart && cart.item_count > 0) resetTimer();
      if (detail.open !== false && config.autoOpenOnAdd !== false && !checkoutPending && !checkoutStarted) {
        openDrawer({ source: 'add-to-cart', refresh: !detail.cart });
      }
      if (!detail.cart && alreadyOpen) fetchCart();
    }
    function onCartError(event) {
      cartFailure += 1;
      // Retain errors received while the drawer is initializing/closed too.
      showError(event.detail && event.detail.message || config.errorMessage);
    }
    function onCartState(event) {
      if (event.detail && Array.isArray(event.detail.items)) render(event.detail);
    }
    function onOtherCartUpdate(event) {
      if (!event.detail || !event.detail._clyroRevision) fetchCart();
    }
    function onWindowFocus() {
      if (isOpen && !checkoutPending && !checkoutStarted) fetchCart();
    }

    function rememberCheckoutReturn() {
      if (inThemeEditor || config.enabled === false) return;
      var url;
      try { url = new URL(window.location.href); } catch (_) { return; }
      url.searchParams.delete('cart_open');
      var path = url.pathname + url.search + url.hash;
      if (/(^|\/)(cart|checkout|checkouts)(\/|$)/i.test(url.pathname) || /\/pages\/cart-return(?:\/|$)/i.test(url.pathname)) return;
      var payload = { path: path, at: Date.now() };
      try {
        window.sessionStorage.setItem('clyro:checkout-return', JSON.stringify(payload));
        window.sessionStorage.setItem('clyro:last-storefront-path', path);
      } catch (_) {}
      try {
        window.history.replaceState(Object.assign({}, window.history.state || {}, {
          clyroCheckoutReturn: payload
        }), '', window.location.href);
      } catch (_) {}
    }

    function clearCheckoutReturn() {
      try { window.sessionStorage.removeItem('clyro:checkout-return'); } catch (_) {}
      try {
        if (window.history.state && window.history.state.clyroCheckoutReturn) {
          var state = Object.assign({}, window.history.state);
          delete state.clyroCheckoutReturn;
          window.history.replaceState(state, '', window.location.href);
        }
      } catch (_) {}
    }

    function openOnCartReturn(event) {
      if (inThemeEditor || destroyed || config.enabled === false) return false;
      var url;
      try { url = new URL(window.location.href); } catch (_) { return false; }
      var explicit = url.searchParams.get('cart_open') === '1';
      url.searchParams.delete('cart_open');
      var path = url.pathname + url.search + url.hash;
      var recovery, departure;
      try { recovery = JSON.parse(window.sessionStorage.getItem('clyro:cart-return') || 'null'); } catch (_) {}
      try { departure = JSON.parse(window.sessionStorage.getItem('clyro:checkout-return') || 'null'); } catch (_) {}
      if (!departure) try { departure = window.history.state && window.history.state.clyroCheckoutReturn; } catch (_) {}
      function matches(payload) {
        var age = payload && Date.now() - Number(payload.at);
        return payload && payload.path === path && age >= 0 && age < 2 * 60 * 60 * 1000;
      }
      var back = !!(event && event.persisted);
      try {
        var navigation = window.performance.getEntriesByType('navigation')[0];
        back = back || !!(navigation && navigation.type === 'back_forward');
      } catch (_) {}
      var fromCheckout = false;
      try { fromCheckout = /(^|\/)checkouts?(\/|$)/i.test(new URL(document.referrer).pathname); } catch (_) {}
      if (!explicit && !matches(recovery) && !(matches(departure) && (back || fromCheckout))) return false;
      // Consume before opening so closing or refreshing cannot reopen it.
      clearCheckoutReturn();
      try { window.sessionStorage.removeItem('clyro:cart-return'); } catch (_) {}
      if (explicit) try { window.history.replaceState(window.history.state, '', path); } catch (_) {}
      checkoutStarted = false;
      cancelCheckout();
      if (isOpen) fetchCart();
      else openDrawer({ source: 'checkout-return', refresh: true });
      return true;
    }

    function onPageShow(event) {
      checkoutStarted = false;
      cancelCheckout();
      if (checkoutButton) {
        checkoutButton.classList.remove('is-loading');
        checkoutButton.disabled = !cart || cart.item_count < 1;
      }
      if (!openOnCartReturn(event) && event.persisted && isOpen) fetchCart();
    }

    function onVisibilityChange() {
      if (document.visibilityState === 'visible' && checkoutStarted) {
        checkoutStarted = false;
        cancelCheckout();
      }
    }

    function onFloatingClick(event) {
      if (event.isTrusted !== true) return;
      event.preventDefault();
      openDrawer({ source: 'floating-cart', refresh: true });
    }
    var floatingButtons = document.querySelectorAll('[data-cd-floating-open]');

    function destroy() {
      if (destroyed) return;
      destroyed = true;
      clearUpsellAutoplay();
      window.clearTimeout(upsellScrollTimer);
      if (upsellHost && upsellScrollHandler) upsellHost.removeEventListener('scroll', upsellScrollHandler);
      if (shipping) shipping.destroy();
      document.removeEventListener('clyro:shipping:ready', updateShipping);
      document.removeEventListener('clyro:cart-loading', onShippingMutation);
      root.removeEventListener('click', onCheckoutClick, true);
      fetchToken += 1;
      closeDrawer();
      stopTimer(false);
      if (noteHandle) window.clearTimeout(noteHandle);
      root.hidden = true;
      document.removeEventListener('clyro:cart-drawer:open', onExternalOpen);
      document.removeEventListener('clyro:cart-drawer:close', onExternalClose);
      document.removeEventListener('clyro:cart-added', onCartAdded);
      document.removeEventListener('clyro:cart-state', onCartState);
      document.removeEventListener('cart:updated', onOtherCartUpdate);
      window.removeEventListener('focus', onWindowFocus);
      document.removeEventListener('clyro:cart-error', onCartError);
      window.removeEventListener('pageshow', onPageShow);
      document.removeEventListener('clyro:checkout-started', rememberCheckoutReturn);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      floatingButtons.forEach(function (button) { button.removeEventListener('click', onFloatingClick); });
      initialized.delete(root);
      instances.delete(root);
      var current = activeSections.get(sectionKey);
      if (current && current.root === root) activeSections.delete(sectionKey);
    }

    document.addEventListener('clyro:cart-drawer:open', onExternalOpen);
    document.addEventListener('clyro:shipping:ready', updateShipping);
    document.addEventListener('clyro:cart-loading', onShippingMutation);
    document.addEventListener('clyro:cart-drawer:close', onExternalClose);
    document.addEventListener('clyro:cart-added', onCartAdded);
    document.addEventListener('clyro:cart-state', onCartState);
    document.addEventListener('cart:updated', onOtherCartUpdate);
    window.addEventListener('focus', onWindowFocus);
    document.addEventListener('clyro:cart-error', onCartError);
    window.addEventListener('pageshow', onPageShow);
    document.addEventListener('clyro:checkout-started', rememberCheckoutReturn);
    document.addEventListener('visibilitychange', onVisibilityChange);
    floatingButtons.forEach(function (button) { button.addEventListener('click', onFloatingClick); });

    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    if (!config.timerMinutes) {
      try {
        window.sessionStorage.removeItem(timerKey);
        window.sessionStorage.removeItem(timerCartKey);
        window.sessionStorage.removeItem(timerDurationKey);
      } catch (_) {}
    }
    instances.set(root, destroy);
    activeSections.set(sectionKey, { root: root, destroy: destroy, isOpen: function () { return isOpen; } });
    document.dispatchEvent(new CustomEvent('clyro:cart-drawer:ready'));
    openOnCartReturn();
  }

  function boot(scope) {
    scope = scope || document;
    if (scope.matches && scope.matches('[data-clyro-native-cart-drawer]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-clyro-native-cart-drawer]').forEach(init);
  }

  window.clyroNativeCartBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    var nodes = event.target.matches && event.target.matches('[data-clyro-native-cart-drawer]') ? [event.target] : event.target.querySelectorAll('[data-clyro-native-cart-drawer]');
    nodes.forEach(function (root) {
      var destroy = instances.get(root);
      if (destroy) destroy();
    });
  });
})();
